import React from 'react';
import {Image  } from 'react-bootstrap'
import './SkillItem.css'

 const SkillItem = ({skill}) => {

return(
    <div className="skill-item">
        <Image src={skill.iconSkill} className="skill-logo" />
        <h5>{skill.nameSkill}</h5>
    </div>
)

}

export default   SkillItem